
import { axiosInstance, baseURL, handleErrors } from "./auth";
export const DELETE_FILE = async (params) => {
    try {
        let response = await axiosInstance.post(`${baseURL}/common/delete`, params);
        return response.data
    }
    catch (error) {
        handleErrors(error)
    }
}
